module.exports = __webpack_public_path__ + "static/img/finance_bg.80344c2f.jpg";